<template>
    <div>
      <masterList :tableColumns="tableColumns" :module="'productCategories'" :addNew="addNew"></masterList>
    </div>
  </template>
  
  <script>
  import { mapState } from 'vuex';
  import masterList from "../Components/masterList.vue";
  export default {
    components: {
      masterList,
    },
    data() {
      return {
        addNew: "/settings/product-categories/_new",
        tableColumns: [
          {
            prop: "code",
            label: "Code",
            minWidth: 100,
            sortable: true,
            key:"CODE"
          },
          {
            prop: "name",
            label: "Name",
            minWidth: 180,
            sortable: true,
            key:"NAME"
            
          },
          {
            prop: "product_count",
            label: "Products",
            minWidth: 100,
            sortable: true,
            key:"PRODUCTS"
          },
        ]
      };
    },
    mounted(){
      this.updateTableLang()
    },
  
    computed:{
      ...mapState({
        language_terms:(state)=>state.languages.language_terms
      })
    },
  
    watch:{
      language_terms:{
              handler(val){
                  this.updateTableLang()
              },
          }
    },
    methods:{
        updateTableLang(){
        for(let i=0; i<this.tableColumns.length;i++){
           let key = this.tableColumns[i].key
           this.tableColumns[i].label = this.language_terms[key]  
        }
      },
    }
  };
  </script>
  
  <style>
  </style>